module.exports = __webpack_public_path__ + "media/images/creator/monitor/badge@2x-86cba657354474784d7c7322a8cad4fd.png";